import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { getAuthStore } from "~/modules/auth/auth-store";
import { LoginCredentialsType } from "~/modules/auth/credentials";
import { exchangeCodeForSessionMutation } from "~/modules/auth/network";
import { getRedirectToFromState } from "~/modules/auth/utils";

export const Route = createFileRoute("/auth/callback")({
  component: RouteComponent,

  validateSearch: z.object({
    code: z.string().optional(),
    state: z.string().optional(),
  }),
  loaderDeps: ({ search }) => ({
    code: search.code,
    state: search.state,
  }),
  async loader({ deps: { code, state } }) {
    const redirectTo = state ? getRedirectToFromState(state) : undefined;

    if (!code) {
      // if code is missing, just redirect to home
      throw redirect({ to: "/" });
    }

    let data: LoginCredentialsType;

    try {
      data = await exchangeCodeForSessionMutation.trigger({ params: { code, state } });
    } catch {
      return { error: "Failed to exchange code for session" };
    }

    getAuthStore().saveLoginCredentials(data);

    const destination = redirectTo ?? "/home";
    throw redirect({ to: destination });
  },
  pendingComponent: PendingComponent,
});

function PendingComponent() {
  return (
    <div>
      <p>logging you in</p>
    </div>
  );
}

function RouteComponent() {
  const { error } = Route.useLoaderData();

  if (error) {
    return (
      <div>
        <p>error: {error}</p>
      </div>
    );
  }
}
